import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Mail } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Unsubscribe() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const run = async () => {
      try {
        const res = await fetch(`${API}/api/newsletter/unsubscribe/${token}`);
        const data = await res.json();
        setStatus(data.status === 'unsubscribed' ? 'success' : 'error');
        setMessage(data.message);
      } catch {
        setStatus('error');
        setMessage('Something went wrong. Please try again later.');
      }
    };
    run();
  }, [token]);

  return (
    <div style={{
      minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '40px 20px',
    }}>
      <div style={{
        textAlign: 'center', maxWidth: 440, width: '100%',
        background: 'var(--white, #fff)', borderRadius: 16,
        border: '1px solid var(--border, #e5e7eb)', padding: '48px 36px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
      }}>
        {status === 'loading' && (
          <>
            <Mail size={40} style={{ color: '#9945FF', marginBottom: 16 }} />
            <h2 style={{ fontSize: 20, margin: '0 0 8px' }}>Processing...</h2>
            <p style={{ color: '#6b7280', fontSize: 14 }}>Updating your subscription preferences</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle size={40} style={{ color: '#10B981', marginBottom: 16 }} />
            <h2 style={{ fontSize: 20, margin: '0 0 8px' }} data-testid="unsubscribe-success">Unsubscribed</h2>
            <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.6 }}>{message}</p>
            <p style={{ color: '#9ca3af', fontSize: 13, marginTop: 16 }}>
              We're sorry to see you go. You can always resubscribe from our website.
            </p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle size={40} style={{ color: '#EF4444', marginBottom: 16 }} />
            <h2 style={{ fontSize: 20, margin: '0 0 8px' }} data-testid="unsubscribe-error">Oops</h2>
            <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.6 }}>{message}</p>
          </>
        )}
        <Link to="/" style={{
          display: 'inline-block', marginTop: 24, color: '#9945FF',
          textDecoration: 'none', fontSize: 14, fontWeight: 500,
        }}>
          ← Back to Skye AI
        </Link>
      </div>
    </div>
  );
}
